export default {
  HARDWARE: "Matériel",
  ADMINISTRATION: "Administration",
  DIGITAL_SALES_TOOLS: "Étude en ligne",
}
